import styles from "@styles/Login.module.scss";
import { Text, Button, ButtonGroup } from "@eventsquare/uikit";
import {
  Form,
  FormLabel,
  FormInput,
  FormFieldset,
  FormGroup,
} from "@eventsquare/uikit/forms";
import * as yup from "yup";

interface RegisterFormValues {
  email: string;
  password: string;
  repeatPassword: string;
}

const Register = () => {
  const initialValues: RegisterFormValues = {
    email: "",
    password: "",
    repeatPassword: "",
  };

  const yupSchema = yup.object().shape({
    email: yup
      .string()
      .email("Please provide a valid email")
      .required("Please provide an email"),
    password: yup
      .string()
      .min(8, "Password should be at least 8 characters")
      .required("Please provide a password"),
    repeatPassword: yup
      .string()
      .oneOf([yup.ref("password")], "Passwords must match")
      .required("Please repeat your password"),
  });

  const handleSubmit = (values: RegisterFormValues) => {
    console.log("REGISTERED", values);
    window.location.href = "/verify";
  };

  return (
    <div className={styles.content}>
      <div className={styles.body}>
        <Text variant="h1">Create new account</Text>
        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          validationSchema={yupSchema}
        >
          <FormFieldset>
            <FormGroup>
              <FormLabel htmlFor="email">E-mail</FormLabel>
              <FormInput
                name="email"
                placeholder="johndoe@eventsquare.co"
                type="email"
                autoComplete="email"
              />
            </FormGroup>
            <FormGroup>
              <FormLabel htmlFor="password">Password</FormLabel>
              <FormInput
                name="password"
                placeholder="Fill in your password"
                type="password"
                autoComplete="new-password"
              />
            </FormGroup>
            <FormGroup>
              <FormLabel htmlFor="repeatPassword">Repeat Password</FormLabel>
              <FormInput
                name="repeatPassword"
                placeholder="Fill in your password"
                type="password"
                autoComplete="new-password"
              />
            </FormGroup>
          </FormFieldset>
          <ButtonGroup>
            <Button type="submit">Sign Up</Button>
            <Text variant="small">
              By signing up you agree with the{" "}
              <a
                href="https://www.eventsquare.co/be-en/docs/conditions"
                target="_blank"
                rel="noopener noreferrer"
              >
                General Conditions
              </a>{" "}
              and our{" "}
              <a
                href="https://www.eventsquare.co/be-en/docs/privacy"
                target="_blank"
                rel="noopener noreferrer"
              >
                privacy policy
              </a>
              .
            </Text>
          </ButtonGroup>
        </Form>
      </div>
    </div>
  );
};

export default Register;
